import {useTitle} from "react-use";

export const DocumentTitle = ({title}: {title: string}): JSX.Element => {
  useTitle(title);

  return null;
};
